import styled from "@emotion/styled";

export const LensDetailsIcon = styled.div<{ iconUrl: string }>`
    width: 49px;
    height: 49px;

    background: center 0 / contain no-repeat url(${({ iconUrl }) => iconUrl});
    border: 4px solid #f7f8f9;
    border-radius: 50%;
`;
